// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TableViewIcon from "@mui/icons-material/TableView";


class AgentNodeCreate extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Продолжить',
            buttonColor: 'neutral',
            ready: true,
        })
    }

    async beforeModalOpen(){
        let formFields = await this.retrieveFields()
        return {
            modalLabel: 'Добавление узла агента',
            modalIcon: TableViewIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
        }
    }

    async retrieveFields(){
        const url = `agent_node/create_form/`;
        const api = new BaseApi();

        let response = await api.get(
            url,
            {
                fields: JSON.stringify(
                    [
                        'title',
                        'xtype',
                    ]
                )
            }
        );

        return response.data
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        formDataObj.prev_step = this.props.agentNode.id;
        formDataObj.agent = this.props.agentNode.agent;
        formDataObj.x_coordinate = this.props.agentNode.x_coordinate + 300;
        const url = `agent_node/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            if (typeof this.props.callBack == 'function') {
                await this.props.callBack();
            }
            await this.setModalOpenFalse();
        }
        return response
    }
}

export default AgentNodeCreate
